// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import wrap from '@vue/web-component-wrapper'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueLazyload from 'vue-lazyload'

import App from './App'
import store from '@/store/index'
import router from './router'
import i18n from '@/i18n/index'
import 'normalize.css'
import './registerServiceWorker'
import './filters'
import './directives'

if (process.env.NODE_ENV === 'production') {
  // adds GA
  require('./gtm.js')

  // adds Sentry profiler
  if(process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
      dsn: `${process.env.VUE_APP_SENTRY_DSN}`,
      integrations: [
        new Integrations.Vue({
          Vue,
          attachProps: true,
        }),
      ],
    })
  }
}

Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})
Vue.use(require('vue-shortkey'))
Vue.use(VueLazyload)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

// Expose config in gloabl app config
Object.defineProperties(Vue.prototype, {
  $config: {
    get: function () {
      return {
        'api_key': process.env.VUE_APP_API_KEY || '',
        'booksync_url': process.env.VUE_APP_BOOKSYNC_URL + '/api' || '',
        'dpm_url': process.env.VUE_APP_DPM_URL || '',
        'talkbook_url': process.env.VUE_APP_TALKBOOK_URL || '',
        'dict_url': process.env.VUE_APP_DICT_URL || ''
      }
    }
  }
})

const pageContentElement = wrap(Vue, () => import('@/components/BookPageContent'))
if (typeof (window.customElements) !== 'undefined') {
  window.customElements.define('book-page-content', pageContentElement, {
    shadow: true // you can set shadow root for element. Only works if native implementation is available.
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>'
})
